import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const VerifiedOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M18.4 16.56v1.51c0 .18-.15.33-.33.33H3.93c-.18 0-.33-.15-.33-.33v-5.44h9.03A9.76 9.76 0 0 1 12.2 11H3.6V9.15c0-.18.15-.33.33-.33h8.05c-.02-.53-.01-1.07 0-1.6H3.93C2.87 7.22 2 8.09 2 9.15v8.92C2 19.13 2.87 20 3.93 20h14.14c1.06 0 1.93-.87 1.93-1.93v-2.32c-.46.32-1 .59-1.6.81Z" />
      <Path d="M17.49 15.59c-.06 0-.12 0-.18-.02-4.05-1.08-4.42-4.63-4.25-7.96 0-.19.09-.36.23-.49.14-.12.33-.19.51-.18.02 0 1.98.09 3.17-1.15.27-.28.7-.29.98-.03.01.01 1.42 1.29 3.23 1.17.19-.01.37.05.51.18.14.12.22.3.23.49.17 3.33-.2 6.88-4.25 7.96-.06.02-.12.02-.18.02v.01Zm-3.06-7.27c-.08 3.49.81 5.17 3.06 5.84 2.25-.67 3.13-2.34 3.06-5.83-1.35-.1-2.44-.72-3.04-1.14-1.05.82-2.3 1.06-3.07 1.13h-.01Z" />
      <Path d="M16.86 12.51c-.18 0-.36-.07-.5-.21l-1.14-1.14a.706.706 0 0 1 0-.99c.27-.27.72-.27.99 0l.65.65 1.91-1.91c.27-.27.72-.27.99 0s.27.72 0 .99l-2.4 2.4c-.14.14-.32.21-.5.21Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default VerifiedOutlined
